import React from 'react'

export const Header = () => {
  return (
    <h2> Budget Manager </h2>
  )
}
